import { render, staticRenderFns } from "./calculationDetails.vue?vue&type=template&id=74d0cbaf&scoped=true&"
import script from "./calculationDetails.vue?vue&type=script&lang=js&"
export * from "./calculationDetails.vue?vue&type=script&lang=js&"
import style0 from "./calculationDetails.vue?vue&type=style&index=0&id=74d0cbaf&lang=less&scoped=true&"
import style1 from "./calculationDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0cbaf",
  null
  
)

export default component.exports